import Chip from '@mui/joy/Chip';
import Tooltip from '@mui/joy/Tooltip';
import Success from 'components/Success';
import FancyIcon from 'components/FancyIcon';
export default function CopyChip({ copyText, children}: { copyText: string, children: React.ReactNode }) {

    return (
        <Tooltip arrow title="Copy to clipboard">
        <Chip
                startDecorator={<FancyIcon name="ContentCopy" />}
                onClick={() => {
                    navigator.clipboard.writeText(copyText);
                    Success("Copied to clipboard");
                }}
        >{children}</Chip>
        </Tooltip>
    );
}
